import { millisecondsToMinutes } from 'date-fns';
import { Toaster } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import { Outlet, ScrollRestoration } from 'react-router';
import { useStores } from './common/hooks';
import { EoNoAccessPage } from './pages/page-eo-no-access/EoNoAccessPage';
import { CustomMessageBar, UserImpersonatedBanner } from './pages/shared-components';
import Footer from './pages/shared-components/Footer';
import { Header } from './pages/shared-components/header';
import { APP_TOASTER_ID } from './shared/toast';

const RootLayoutImpl: React.FC = () => {
  const {
    userStore,
    idleStore,
  } = useStores();

  if (userStore.isUserSubjectToEORestrictions) {
    return <EoNoAccessPage />;
  }

  return (
    <div className='App'>
      <ScrollRestoration />
      <Header />
      {userStore.isUserImpersonated && <UserImpersonatedBanner />}
      {
        (idleStore.remainingTime !== 0 && millisecondsToMinutes(idleStore.remainingTime) <= 5) && (
          <CustomMessageBar
            message={(<span>For your security, you will be automatically signed-out in 5 minutes due to inactivity.</span>)}
            notificationTypeCode='warning'
            showDismissButton={false}
          />
        )
      }
      <Outlet />
      <Footer />
      <Toaster
        toasterId={APP_TOASTER_ID}
      />
    </div>
  );
};

export const RootLayout = observer(RootLayoutImpl);